module.exports = __webpack_public_path__ + "static/img/121.cbe6f9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/121.png
// module id = zxgb
// module chunks = 0